import Vue from 'vue'
import App from './App.vue'
import VueTour from 'vue-tour';
import VueAnalytics from 'vue-analytics'
import VTooltip from 'v-tooltip'
import { Auth0Plugin } from '@/Auth0Plugin';
import 'vue-tour/dist/vue-tour.css';

Vue.config.productionTip = false

Vue.use(VTooltip)
Vue.use(VueTour)
Vue.use(VueAnalytics, {
  id: 'UA-136596846-1'
});

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain: "dev-ny08avcl.us.auth0.com",
  clientId: "2mbzLUiZAnbRX2v3jtqsRKQKwCg9NkK7",
  onRedirectCallback: appState => {
    router.push(
      window.location.href
      // appState && appState.targetUrl
      //   ? appState.targetUrl
      //   : window.location.pathname
    );
  }
});

new Vue({
  render: h => h(App),
}).$mount('#app')
